module.exports = __webpack_public_path__ + "static/img/zh_HANT2.1cabf5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/zh_HANT2.png
// module id = 7bGL
// module chunks = 1